import { useEffect } from "react";

// Su telefono le tabelle .rt diventano schede: copia l'intestazione di colonna in data-label di ogni cella.
const labelTable = (table) => {
  const heads = [];
  table.querySelectorAll("thead tr:first-child th").forEach((th) => {
    const span = th.colSpan || 1;
    for (let i = 0; i < span; i++) heads.push((th.innerText || "").trim());
  });
  table.querySelectorAll("tbody tr, tfoot tr").forEach((tr) => {
    let col = 0;
    Array.from(tr.children).forEach((td) => {
      const span = td.colSpan || 1;
      const label = span > 1 ? "" : heads[col] || "";
      if (td.getAttribute("data-label") !== label) td.setAttribute("data-label", label);
      col += span;
    });
  });
};

export const useResponsiveTables = () => {
  useEffect(() => {
    let frame = 0;
    const run = () => {
      frame = 0;
      document.querySelectorAll("table").forEach((t) => {
        if (t.dataset.rt === "off") return;
        t.classList.add("rt");
        labelTable(t);
      });
    };
    const schedule = () => { if (!frame) frame = requestAnimationFrame(run); };
    run();
    const obs = new MutationObserver(schedule);
    obs.observe(document.body, { childList: true, subtree: true });
    return () => { obs.disconnect(); if (frame) cancelAnimationFrame(frame); };
  }, []);
};
